$('.btn:not(.cta):not(.surveyQuestionBanner__button)').on('click', function () {
    if($('#surveyQuestionBanner').length) {
        const surveyQuestionBannerHeight = Math.floor($('#surveyQuestionBanner').outerHeight());

        if($('#discountBanner').length) {
            $('html, body').animate({
                scrollTop: $("#discountBanner").offset().top - surveyQuestionBannerHeight
            }, 1200);
        } else {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top - surveyQuestionBannerHeight
            }, 1200);
        }
    } else {
        if($('#discountBanner').length) {
            $('html, body').animate({
                scrollTop: $("#discountBanner").offset().top
            }, 1200);
        } else {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top
            }, 1200);
        }
    }
})